import { Typography } from 'antd';
import { IRestColumnProps } from 'components/rest/Table/TableColumn';
import RestList from 'containers/rest/List';
import { useMemo } from 'react';
import { DynamicObjectType, FilterFromUrlResponseType } from 'types/commons';
import { ProductTableStyle } from './styles';
import { ExpandableConfig } from 'rc-table/lib/interface';
import AvatarCol from 'components/rest/AvatarCol';
import { getDataDetail } from 'utils/tools';
import SelectionActions from './SelectionActions';

const DEFAULT_COLUMNS: IRestColumnProps[] = [
  {
    name: 'thumbnail',
    title: 'Thumbnail',
    render: (d, r) => {
      return <AvatarCol src={d || r?.medias?.[0]?.url} />
    },
    isDefault: true,
  },
  {
    name: 'detail',
    title: 'Name',
    render: (detail: DynamicObjectType[], record) => (
      <div>
        <div className="fw-500">{getDataDetail(record)?.name}</div>
        <div className="text-secondary">SKU:{record?.sku}</div>
      </div>
    ),
    isDefault: true,
  },
  {
    name: 'slug',
    title: 'Slug',
    render: (d: string, r: DynamicObjectType) => (
      <a
        href={
          r?.isCombo ? `/combo-products/${r.id}/edit` : `/products/${r.id}/edit`
        }
      >
        <Typography.Paragraph
          ellipsis={{ rows: 1 }}
          style={{ width: 150 }}
          className="text-highlight-secondary"
        >
          {d}
        </Typography.Paragraph>
      </a>
    ),
    isDefault: true,
  },
];
const INIT_FILTER = {
  join: ['detail', 'variants', 'variants.locationStocks'],
};

const SEARCH_KEYS = ['detail.name', 'slug', 'sku'];

type ProductTableProps = {
  model?: string;
  columns?: IRestColumnProps[];
  initialFilter?: FilterFromUrlResponseType;
  initSelectedRowKeys?: React.Key[];
  handleSelectedRowKeys?: (
    selectedRowKeys: React.Key[],
    data: DynamicObjectType[],
  ) => void;
  expandable?: ExpandableConfig<{
    id: string;
  }>;
  formatListData?: (data: DynamicObjectType[]) => DynamicObjectType[];
  searchKeys?: string[];
  placeholderInputSearch?: string;
};

export default function ProductTable({
  columns,
  initSelectedRowKeys,
  handleSelectedRowKeys,
  expandable,
  formatListData,
  initialFilter = INIT_FILTER,
  model = 'searchProducts',
  searchKeys = SEARCH_KEYS,
  placeholderInputSearch,
}: ProductTableProps) {
  const _columns = useMemo(() => {
    return columns || DEFAULT_COLUMNS;
  }, [columns]);

  return (
    <ProductTableStyle>
      <RestList
        hasExport={false}
        hasShowFilter={false}
        hasDraggable={false}
        hasImport={false}
        hasEdit={false}
        hasDel={false}
        hasCustomLayout={false}
        model={model}
        columns={_columns}
        initialFilter={initialFilter}
        rowSelectionActions={<SelectionActions />}
        initSelectedRowKeys={initSelectedRowKeys}
        handleSelectedRowKeys={handleSelectedRowKeys}
        searchKeys={searchKeys}
        expandable={expandable}
        formatListData={formatListData}
        placeholderInputSearch={placeholderInputSearch}
      ></RestList>
    </ProductTableStyle>
  );
}
